var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUipathSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "32px",
    height: "32px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0449",
    d: "M6,6h36v36H6V6z M38,38V10H10v28H38z M12.97,15.288v10.908c0,4.99,2.736,7.906,7.366,7.906 s7.51-2.974,7.51-7.906V15.288h-3.73v10.908c0,2.822-1.202,4.385-3.694,4.385s-3.73-1.656-3.73-4.385V15.288h-3.73H12.97z M32.654,17.513c1.325,0,2.282-0.9,2.282-2.225c0-1.325-0.965-2.282-2.282-2.282c-1.318,0-2.282,0.929-2.282,2.282 C30.372,16.642,31.337,17.513,32.654,17.513z M30.79,19.284v14.638h3.73V19.284H30.79z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUipathSvg);
export default __webpack_public_path__ + "static/media/uipath-svg.7434bb429b68db6db3ab76cda423609b.svg";
export { ForwardRef as ReactComponent };